import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Subscription } from 'rxjs';
import { MeetingSchedulerStoreService } from '../../data-providers/meeting-scheduler-store.service';
import { DurationOption } from '../duration-multi-select/duration-multi-select.component';
import { POSTHOG_ACTIONS, POSTHOG_CATEGORIES, POSTHOG_KEYS } from '../../constants';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'meeting-scheduler-settings-availability-increment',
  templateUrl: './availability-increment-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvailabilityIncrementCardComponent implements OnDestroy {
  @Input() preferredAvailabilityIncrement: number;
  @Input() enableTracking: boolean;

  options: DurationOption[] = [
    { seconds: 900, label: '15' },
    { seconds: 1800, label: '30' },
    { seconds: 3600, label: '60' },
  ];

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly meetingSchedulerStoreService: MeetingSchedulerStoreService,
    private readonly alertService: SnackbarService,
    private readonly translate: TranslateService,
    private readonly analyticsService: ProductAnalyticsService,
  ) {}

  async onDurationSelected(option: DurationOption): Promise<void> {
    try {
      await this.meetingSchedulerStoreService.updateUserPreferences({ availabilityIncrement: option.seconds });
      if (this.enableTracking) {
        this.analyticsService.trackEvent(
          POSTHOG_KEYS.HOST_PREFERENCE_UPDATED,
          POSTHOG_CATEGORIES.USER,
          POSTHOG_ACTIONS.CLICK,
        );
      }
      this.alertService.openSuccessSnack(
        'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.AVAILABILITY_INCREMENT.SUCCESS',
      );
    } catch (err) {
      this.translate.instant('MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.AVAILABILITY_INCREMENT.ERROR');
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
